export const API_End_Point = {
  Login: '/Account/Login',
  Register: '/Account/Register',
  SendOTP: (EmailId: any) => `/Account/VerifyEmail?EmailId=${EmailId}`,
  ForgotPassword: (EmailId: any) => `/Account/ForgotPassword?EmailId=${EmailId}`,
  VerifyEmailOTP: (email: string, otp: string) => `/Account/OTPVerify?EmailId=${encodeURIComponent(email)}&OTP=${encodeURIComponent(otp)}`,
  GetCount: (userId: number, financialYear: string) => `/Book/GetOrderCountByBookType?UserId=${userId}&FinancialYear=${financialYear}`,
  BookDetailsByBookTypes: (userId: number, financialYear: string, bookType: number,classId: number) =>
    `/Book/Get_BookDetailsByBookType?UserId=${userId}&FinancialYear=${financialYear}&bookType=${bookType}&classId=${classId}`,
  EnquiryFrom: '/Book/EnquiryFrom',
  Chapter_Book_Wise: (Book_Id: any) => `/ManageMock/Chapter_Book_Wise?Book_Id=${Book_Id}`,
  MyOrders: (userId: number, financialYear: string) => `/Book/get_userOrders?UserId=${userId}&financialYear=${financialYear}`,
  TrackOrder: (orderId: number) => `/Book/Track_PacketStatus?orderId=${orderId}`,
  MockTestPlan: (userId: number) => `/ManageMock/GetPlan?userId=${userId}`,
  CreateOrder: `/Book/CreateOrder`,
  CheckoutWithoutLogin: `/Book/Checkout_Without_Login`,
  UpdatePaymentFailed: `/Book/UpdatePayment_InCase_Fialed`,
  VerifyPayment: `/Book/Update_Payment_Info`,
  GetBillingAddress: `/ManageMock/Get_Shipping_Address_By_UserId`,
  InsertBillingAddressGe: `/ManageMock/UserBillingAddressInsert`,
  Get_Instruction_For_Mock: (EventLetter: string, ClassId: number, Stream: any) => `/ManageMock/Get_Instruction_For_Mock?eventLetter=${EventLetter}&classId=${ClassId}&stream=`,
  StartMockTest: `/ManageMock/StartMockTest`,
  Get_Analitical_Progress: `/ManageMock/Get_Analitical_Progress`,
  ViewReport: (PowerPrepStatusId: number) => `/ManageMock/ViewReport?PowerPrepStatusId=${PowerPrepStatusId}`,
  ChangePassword: '/Account/ChangePassword',
  PurchasePlans: '/ManageMock/Purchased_Plans',
  MyMockTest: '/ManageMock/MyMockTest',
  GetChild: '/ManageMock/GetChild',
  AddChild: '/ManageMock/AddChild',
  switchChild: (ChildId: number) => `/ManageMock/SwitchChild?ChildId=${ChildId}`,
  LodecountryStateData:`/ManageMock/Get_CountryState`,
  UpdateUserDetails: '/Account/UpdateUserDetails',

};



